import * as React from "react";
import { Box, Menu, MenuItem, Typography, styled } from "@mui/material";
import { useNavigate } from "react-router-dom";

interface Props {
  setMobileNav: React.Dispatch<React.SetStateAction<boolean>>;
  photo: string[];
  mobileNav: boolean;
}

const LinkText = styled(Typography)(({ theme }) => ({
  padding: `${theme.palette.custom.small} 0px`,
  "&:hover": {
    cursor: "pointer",
    opacity: ".5",
  },
}));

export const PhotoMenu: React.FC<Props> = ({
  setMobileNav,
  photo,
  mobileNav,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const navigate = useNavigate();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (route: string) => {
    navigate(`/photography/${route}`);
    setAnchorEl(null);
    setMobileNav(false);
  };

  const handleCloseOutside = () => {
    setAnchorEl(null);
  };

  return (
    <Box>
      <LinkText
        sx={{ color: mobileNav ? "black" : "white" }}
        onMouseEnter={handleClick}
      >
        PHOTO
      </LinkText>
      <Menu open={open} anchorEl={anchorEl} onClose={handleCloseOutside}>
        {photo.map((item, key) => (
          <MenuItem key={key} onClick={() => handleClose(item)}>
            {item.toUpperCase().replaceAll("-", " ")}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};
